/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ResponsiveHeroImage } from "@quintype/components";
import { SvgHandler } from "../../svg-handler/svg-handler";
import loaderIcon from "../../../../assets/icons/loading.svg";
import "./purchased-stories.m.css";
import { CustomLink } from "../../custom-link";
import { getLocaleDate } from "../../../utils";

export const PurchasedStoriesBlock = ({ subscriptions, purchasedStories = {}, localizedMonths }) => {
  const [assetStories, setAssetStories] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const dynamicAssets = subscriptions.filter((plan) => plan["subscription_type"] === "dynamic_asset");
  const {
    storyName: localizedStoryName = "",
    date: localizedDate = "",
    noStories: localizedNoStories = "",
    purchasedStoriesSubscription: localizedPurchasedStories = "",
  } = purchasedStories;
  useEffect(() => {
    !dynamicAssets.length && setIsDataLoading(false);
    dynamicAssets.length &&
      dynamicAssets.forEach(async (asset) => {
        const response = await fetch(`/api/v1/stories/${asset.dynamic_assets[0].id}`);
        const json = await response.json();
        setAssetStories(
          assetStories.concat([
            {
              ...asset,
              story: json.story,
            },
          ])
        );
        setIsDataLoading(false);
      });
  }, [dynamicAssets.length]);

  if (isDataLoading)
    return (
      <div styleName="loader">
        <SvgHandler width="50" height="50" clazzName="callout-loader" xlinkHref={loaderIcon} />
      </div>
    );
  if (!assetStories.length && !isDataLoading)
    return <div styleName="info-message">{localizedNoStories || "No Purchased Stories"}</div>;
  return (
    <>
      <h3 styleName="purchased-story">{localizedPurchasedStories || "Purchased stories"}</h3>
      <div>
        <div styleName="placeholder">
          <div styleName="content story-name">{localizedStoryName || "Story Name"}</div>
          <div styleName="content">{localizedDate || "Date"}</div>
        </div>
        <div>
          {assetStories.map((asset) => {
            return (
              <div key={asset.id} styleName="wrapper placeholder">
                <ResponsiveHeroImage
                  story={asset.story}
                  aspectRatio={[4, 3]}
                  alt={asset.story.headline}
                  defaultWidth={480}
                  widths={[250, 480, 640]}
                  sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
                  imgParams={{ auto: ["format", "compress"], fit: "max" }}
                />

                <p styleName="headline">
                  <CustomLink href={asset.story.slug}>{asset.story.headline}</CustomLink>
                </p>
                {asset.created_at && <div styleName="date">{getLocaleDate(asset.created_at, localizedMonths)}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

PurchasedStoriesBlock.propTypes = {
  subscriptions: PropTypes.array,
  localizedMonths: PropTypes.object,
  purchasedStories: PropTypes.shape({
    storyName: PropTypes.string,
    date: PropTypes.string,
    noStories: PropTypes.string,
    purchasedStoriesSubscription: PropTypes.string,
  }),
};
